import { Component, inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatListModule } from '@angular/material/list';

@Component({
  selector: 'app-change-locale-bottomsheet',
  templateUrl: './change-locale-bottomsheet.component.html',
  styleUrls: ['./change-locale-bottomsheet.component.scss'],
  imports: [MatListModule],
})
export class ChangeLocaleBottomsheetComponent {
  private _bottomSheetRef = inject<MatBottomSheetRef<ChangeLocaleBottomsheetComponent>>(MatBottomSheetRef);
  data = inject(MAT_BOTTOM_SHEET_DATA);

  proceed(): void {
    this._bottomSheetRef.dismiss(true);
  }

  stay(): void {
    this._bottomSheetRef.dismiss(false);
  }
}
